module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEUAAACnej3aAAAAAXRSTlNNSIvlSwAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/template/ie8_opacity_dark_30.png
// module id = ../../../../../src/assets/img/template/ie8_opacity_dark_30.png
// module chunks = 2